import { useState } from "react";
import { BadgeCheck, CreditCard, FileQuestion, Handshake, Mail, MonitorX, Send } from "lucide-react";
import { api, formatError } from "../lib/api";

export const REASONS = ["Question about a certification", "Payment or refund", "Problem taking a test", "Certificate or verification", "Business or partnership", "Other"];
const TOPICS = [[FileQuestion, "Certifications", "Syllabus, fees and which test fits you"], [CreditCard, "Payments & refunds", "Include your order ID for faster help"],
  [MonitorX, "Test problems", "Timer, submission or access issues"], [BadgeCheck, "Certificates", "Downloads, name corrections, verification"], [Handshake, "Partnerships", "Hiring, training and bulk enrolment"]];
const EMPTY = { name: "", email: "", reason: "", message: "", phone: "", certification: "", website: "" };

const HelpPanel = () => (
  <aside className="contact-help" data-testid="contact-help-panel">
    <div className="section-kicker">HOW WE CAN HELP</div>
    {TOPICS.map(([Icon, title, text]) => <div className="contact-topic" key={title}><Icon size={18} /><div><b>{title}</b><span>{text}</span></div></div>)}
    <div className="contact-direct"><Mail size={16} /> Contact us: <a href="mailto:help@availity.si" data-testid="contact-email-link">help@availity.si</a></div>
    <p>We reply by email within 2 working days.</p>
  </aside>
);

export const ContactForm = () => {
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState({ busy: false, error: "", sent: false });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, error: "", sent: false });
    try { await api.post("/contact", f); setState({ busy: false, error: "", sent: true }); setF(EMPTY); }
    catch (err) { setState({ busy: false, error: formatError(err), sent: false }); }
  };
  return (
    <div className="contact-layout">
      <form className="contact-form" onSubmit={submit} data-testid="contact-form">
        {state.sent && <div className="notice" data-testid="contact-success">Thanks — your message has been sent. Our team will reply to you by email.</div>}
        <div className="form-row two">
          <label className="form-field"><span>Name *</span><input data-testid="contact-name-input" value={f.name} onChange={set("name")} minLength={2} maxLength={80} required /></label>
          <label className="form-field"><span>Email *</span><input data-testid="contact-email-input" type="email" value={f.email} onChange={set("email")} required /></label>
        </div>
        <div className="form-row two">
          <label className="form-field"><span>Phone (optional)</span><input data-testid="contact-phone-input" value={f.phone} onChange={set("phone")} maxLength={30} /></label>
          <label className="form-field"><span>Certification (optional)</span><input data-testid="contact-certification-input" value={f.certification} onChange={set("certification")} maxLength={120} /></label>
        </div>
        <label className="form-field"><span>Reason *</span><select data-testid="contact-reason-select" value={f.reason} onChange={set("reason")} required><option value="">Choose a reason</option>{REASONS.map((r) => <option key={r} value={r}>{r}</option>)}</select></label>
        <label className="form-field"><span>Message *</span><textarea data-testid="contact-message-input" rows={6} value={f.message} onChange={set("message")} minLength={10} maxLength={3000} required /></label>
        <input className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" value={f.website} onChange={set("website")} name="website" />
        {state.error && <div className="error" data-testid="contact-error">{state.error}</div>}
        <button className="button primary" data-testid="contact-submit-button" disabled={state.busy}><Send size={16} /> {state.busy ? "Sending…" : "Send message"}</button>
      </form>
      <HelpPanel />
    </div>
  );
};
